import { render, staticRenderFns } from "./Bounds.vue?vue&type=template&id=0cd4b2ae&scoped=true"
import script from "./Bounds.vue?vue&type=script&lang=js"
export * from "./Bounds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd4b2ae",
  null
  
)

export default component.exports